import { format, isThisWeek, isThisYear, isToday, isYesterday } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { enUS, fr } from "date-fns/locale";

export const formatDate = (
  date: Date,
  locale: string,
  options: Intl.DateTimeFormatOptions,
) => {
  const dateTimeFormat = new Intl.DateTimeFormat(locale, options);
  return dateTimeFormat.format(date);
};

export const relativeDate = (date: Date, locale: string, timezone?: string) => {
  const dateLocale = locale === "fr" ? fr : enUS;
  const convertedDate = timezone ? toZonedTime(date, timezone) : date;

  if (isToday(date)) {
    return format(
      convertedDate,
      locale === "fr" ? "'Auj.,' p" : "'Today at' p",
      {
        locale: dateLocale,
      },
    );
  }
  if (isYesterday(date)) {
    return format(
      convertedDate,
      locale === "fr" ? "'Hier,' p" : "'Yesterday at' p",
      {
        locale: dateLocale,
      },
    );
  }
  if (isThisWeek(date)) {
    return format(
      convertedDate,
      locale === "fr" ? "EEEE',' p" : "EEEE 'at' p",
      {
        locale: dateLocale,
      },
    );
  }
  if (isThisYear(date)) {
    return format(
      convertedDate,
      locale === "fr" ? "d MMM',' p" : "MMM d 'at' p",
      {
        locale: dateLocale,
      },
    );
  }

  return format(convertedDate, "PP", {
    locale: dateLocale,
  });
};

export const formatDateFilter = (date: Date, locale: string) => {
  const dateTimeFormat = new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  });
  return dateTimeFormat.formatToParts(date).reduce(
    (str, item) =>
      // eslint-disable-next-line no-useless-assignment
      item.type === "literal" ? str : (str += (str ? "-" : "") + item.value),
    "",
  );
};

export const formatRange = (startDate: Date, endDate: Date, locale: string) => {
  const dateTimeFormat = new Intl.DateTimeFormat(locale, {
    month: "short",
    day: "numeric",
  });
  return dateTimeFormat.formatRange(startDate, endDate);
};

export { enUS, fr };
